import base from "/Users/mehakpreetsingh/Documents/NextJs App/monochrome/images/spotify.svg?svg";
import { getParams, mergeSvgAttributes } from "svg-merge-attributes";
export default mergeSvgAttributes(base, getParams("size=22"));